module.exports = "/assets/7bd02dd50fad6e8fd65094177593666e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/V0.png
// module id = 1910
// module chunks = 0